import DeleteConfirmation from './delete-modal'
import InputTypeBasic  from './basic'
import InputTypeDetailed from './detailed'

export default {
  DeleteConfirmation,
  InputTypeBasic,
  InputTypeDetailed
}
